<template>
  <v-container class="NotificationSubscriber">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
      <v-toolbar-title  class="hidden-sd-and-down">
          <h2 v-if="this.user"><v-icon large class="mr-2">mdi-tooltip-account</v-icon>{{ this.user.login }}</h2>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          class="ml-2"
          color="primary"
          @click="cancel"
        >
          {{ $t('global.cancel')}}
        </v-btn>
        <v-btn
          class="ml-2"
          color="primary"
          @click="updateNotificationSubscriber"
        >
          {{ $t('global.update')}}
        </v-btn>
      </div>
    </v-toolbar>

    <div>
      <v-container>
        <v-row>
          <v-col md="12" v-if="this.item">
            <UpdateNotificationSubscriberForm class="ml-2" ref="UpdateNotificationSubscriberForm" :values="item" :errors="violations" />
          </v-col>
        </v-row>
        <Loading :visible="isLoading" />
      </v-container>
    </div>
    </v-sheet>

  </v-container>
</template>

<script>

import { createHelpers } from 'vuex-map-fields';
import { mapActions, mapState,mapGetters } from 'vuex';
import UpdateNotificationSubscriberForm from '../../components/notification/FormNotificationUser.vue';
import Loading from '../../components/Loading';
import NotificationMixin from '../../mixins/NotificationMixin';

const servicePrefix = 'User';
const { mapFields } = createHelpers({
  getterType: 'user/getField',
  mutationType: 'user/updateField'
});

export default {
  name: 'NotificationSubscriber',
  servicePrefix,
  mixins: [NotificationMixin],
  components: {
    Loading,
    UpdateNotificationSubscriberForm
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations']),
    ...mapState('user', {
      updatedata: 'updatedata',
      error: 'error',
    }),
    ...mapGetters('user',{
      dataUser: 'data',
    }),
    ...mapState('notificationusersubscriber', {
      notificationuserupdatedata: 'updatedata',
      error: 'error',
      isLoading: 'isLoading',
    }),
    ...mapGetters('notificationusersubscriber',{
      notificationuserdata: 'data',
    }),
    user: {
      get() { return this.itemUser },
      set(value) { this.itemUser = value; }
    },
  },
  data() {
    return {
      item: null,
      itemUser: {}
    };
  },
  methods: {
    ...mapActions({
      notificationuserPushAction: 'notificationusersubscriber/action',
      notificationuserGetData: 'notificationusersubscriber/data',
      userGetData: 'user/data'
    }),
    cancel() {
      //this.$refs.updateNotificationSubscriber.$v.$reset();
      this.$router.push({ name: `Profil` });
    },
    updateNotificationSubscriber() {
      this.notificationuserPushAction({action: 'mynotificationsubscriberupdate',values: {'notificationusers' :JSON.stringify(this.item)}});
    },
    updated(item) {
      console.log("updated");
      this.$router.push({ name: `Profil` });
      this.showMessage(item.message);
    },

  },
  mounted() {
    if (! this.dataUser('profil')) {
      this.userGetData({data: 'profil'});
    } else {
      this.user = this.dataUser('profil');
    }
    this.notificationuserGetData({data: 'mynotificationsubscriber'});
 },
  watch: {
    actioned(actioned) {
      if (!actioned) {
        return;
      }
      if (this.action == 'mynotificationsubscriberupdate') {
        this.updated(actioned);
      }
    },
    updatedata: function (updatedata) {
      console.log('updatedata');
      if (updatedata == 'profil') {
        this.user = this.dataUser('profil');
      }
    },
    notificationuserupdatedata: function (updatedata) {
      console.log('notificationuserupdatedata');
      if (updatedata == 'mynotificationsubscriber') {

        this.item = Object.assign({}, this.notificationuserdata('mynotificationsubscriber'));
      }
    },
    error(message) {
      message && this.showError(message);
    }
  }
};
</script>
